<template>
  <smd-one-col-layout class="modal-city-list">
    <!--    <smd-loader v-if="isLoading"-->
    <!--                :image="$options.Logo"/>-->
    <smd-header slot="header" nav>
      <span class="ns-icon-ico028"
            slot="left-actions"
            @click="handleCityNoSelection"/>
      <h2 class="Title3 gray-400">Select City</h2>
      <span class="ns-icon-ico001"
            slot="right-actions">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>
    <smd-search class="m-t-15"
                slot="toolbar"
                v-model="search"/>
    <div class="m-t-10">
      <div class="smd-radio__row"
           v-for="(item, index) in filteredCities"
           :key="index">
        <smd-radio v-model="selectedCity"
                   :label="`${item.name}, ${item.region}`"
                   :value="$options.getCityValue(item)"/>
      </div>
    </div>

    <div class="modal-city-list__footer"
         slot="bottom-nav">
      <smd-btn :section="$isDesktop ? '4' : '1'"
               :variant="computedBtnVariant"
               @click="handleCitySelection">
        <text-string label-id="txt202"/>
      </smd-btn>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import CITIES from '@leapfroggr/psgc2/pxapp.json';
  import {filterCityList} from "@leapfroggr/patientappcommons/dist/utils";
  import {getCityValue} from "@/utils";
  import CloseModalMixin from '@/mixins/close-modal-mixin';

  export default {
    name: "modal-city-list",
    mixins: [CloseModalMixin],
    props: {
      existingSelectedCity: {type: Object, default: null},
      emitValueOnly: {type: Boolean, default: false},
      filterCities: {type: [Object, Array], default: null}, // {filterBy, value}
    },
    data() {
      return {
        selectedCity: getCityValue(this.existingSelectedCity),
        search: '',
        isLoading: true
      }
    },
    computed: {
      computedBtnVariant() {
        return this.$isDesktop ? (this.selectedCity ? 'blue-enabled' : 'blue-disabled') : (this.selectedCity ? 'enabled-blue' : 'disabled');
      },
      filteredCities() {
         if (this.filterCities) {
          return CITIES.filter(city => city[this.filterCities.filterBy] === this.filterCities.value[0])
                       .filter(filterCityList(this.search.toLowerCase()));
        }


        return CITIES.filter(filterCityList(this.search.toLowerCase()));
      },
      selectedCityObject() {
        if (!this.selectedCity) return null;
        const selectedCity = this.filteredCities.find((city) => getCityValue(city) === this.selectedCity);
        return selectedCity || null;
      },
    },
    methods: {
      handleCityNoSelection() {
        this.$modal.close(this.existingSelectedCity);
      },
      handleCitySelection() {
        if (this.selectedCity) {
          const value = this.emitValueOnly ? this.selectedCity : this.selectedCityObject;
          this.$modal.close(value);
        }
      }
    },
    getCityValue,
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .modal-city-list__footer {
    @include responsive(desktop) {
      display: flex;
      justify-content: center;
      padding: space(base);
    }
  }
</style>